import request, { Methods, withToken } from "../../../../utils/request";

//* ACTIONTYPES --------------------------------------------
export const GET_SCHEDULE_BY_EMPLOYEE_DEFAULT = "GET_SCHEDULE_BY_EMPLOYEE_DEFAULT";
export const GET_SCHEDULE_BY_EMPLOYEE_REQUEST = "GET_SCHEDULE_BY_EMPLOYEE_REQUEST";
export const GET_SCHEDULE_BY_EMPLOYEE_SUCCESS = "GET_SCHEDULE_BY_EMPLOYEE_SUCCESS";
export const GET_SCHEDULE_BY_EMPLOYEE_ERROR = "GET_SCHEDULE_BY_EMPLOYEE_ERROR";

//* ACTIONS ------------------------------------------------
export const getScheduleByEmployeeDefault = (data) => ({
  type: GET_SCHEDULE_BY_EMPLOYEE_DEFAULT,
  payload: data,
});

export const getScheduleByEmployeeRequest = (payload = {}, callback) => ({
  type: GET_SCHEDULE_BY_EMPLOYEE_REQUEST,
  payload,
  callback,
});

export const getScheduleByEmployeeSuccess = (data) => ({
  type: GET_SCHEDULE_BY_EMPLOYEE_SUCCESS,
  payload: data,
});

export const getScheduleByEmployeeError = (error) => ({
  type: GET_SCHEDULE_BY_EMPLOYEE_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const getScheduleByEmployeeServiceRequest = async ({ idWeek, idEmployee, ...params }) => {
  const options = await withToken({
    method: Methods.GET,
    params: { ...params },
  });

  return request(`/schedules/weeks/${idWeek}/employees/${idEmployee}`, options);
};
